// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"66b9b830","239":"e1570a2d","453":"db704869","455":"04206f68"}[chunkId] + ".chunk.js";
};